// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"230":"LocaleMessagePopover","358":"LanguageSelectionModal","524":"CurrencySelectionModal","650":"LocaleMessageModal"}[chunkId] + "." + {"230":"124132a56f6319183956","358":"a839555d691220fc8c9f","524":"995cb3d0f3c1b51753f6","650":"6b04ee051b9c6b81655e"}[chunkId] + ".js";
};